import { Injectable } from '@angular/core';
import { Store } from '../../@core/store/store';
import { Observable, Subject } from 'rxjs';
import { FilterLoadedState, FilterLoadingErrorState, FilterLoadingState, MoodLoadedState, MoodLoadingErrorState, MoodLoadingState, LineChartLoadingState, LineChartLoadedState,LineChartLoadingErrorState } from './gauge-chart.state';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GaugeChartService extends Store.AbstractService {

  checkFeedbackSubmitted(): Observable<{ userFeedbackSubmitted: boolean, employeeMood: string }> {
    const path = environment.api.feedBack.checkFeedbackSubmitted.endpoint;

    return this.controller.get<{ userFeedbackSubmitted: boolean, employeeMood: string }>(
      path,
      null,
      environment.api.core.base3,
      { Authorization: true }
    );
  }

fetchGraphFilterData() {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new FilterLoadingState());
    }, 0);

    const path = environment.api.feedBack.filter.endpoint;

    me.controller.get(path, null, environment.api.core.base3, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new FilterLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new FilterLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
 fetchMoodFiltrationData(payload: { bu: any;du: any;gender: any;band: any;fromDate: string; baseLocation: any; country: any; toDate: string; deliveryGroup: string }):any {
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new MoodLoadingState());
    }, 0);
   const path = environment.api.feedBack.feedBackData.endpoint;
    this.controller
      .post(path, payload, environment.api.core.base3, { Authorization: true })
      .subscribe({
        next : (data: any) => {
          output.next(new MoodLoadedState(data));
          output.complete();
        },
        error:(e: any) => {
          output.error(new MoodLoadingErrorState(e));
          output.complete();
        }
  });
      return output;
  }

fetchLineChartFiltrationData(payload: { bu: any;du: any;gender: any;band: any;fromDate: string; baseLocation: any; country: any; toDate: string; }):any {
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new LineChartLoadingState());
    }, 0);
   const path = environment.api.feedBack.lineChartData.endpoint;
    this.controller
      .post(path, payload, environment.api.core.base3, { Authorization: true })
      .subscribe({
        next : (data: any) => {
          output.next(new LineChartLoadedState(data));
          output.complete();
        },
        error:(e: any) => {
          output.error(new LineChartLoadingErrorState(e));
          output.complete();
        }
  });
      return output;
  }

}
